import { UI_LAYER } from '@usercentrics/cmp-browser-sdk';
import { VIEW } from '../enums';

export const convertUiViewToSdkLayer = (val: VIEW): UI_LAYER => {
  switch (val) {
    case VIEW.FIRST_LAYER: {
      return UI_LAYER.FIRST_LAYER;
    }
    case VIEW.SECOND_LAYER: {
      return UI_LAYER.SECOND_LAYER;
    }
    case VIEW.PRIVACY_BUTTON: {
      return UI_LAYER.PRIVACY_BUTTON;
    }
    case VIEW.NONE:
    default: {
      return UI_LAYER.NONE;
    }
  }
};
